import { render, staticRenderFns } from "./FormRow.vue?vue&type=template&id=2f90eed0&"
import script from "./FormRow.vue?vue&type=script&lang=js&"
export * from "./FormRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports